import { useMemo, } from "react";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import _ from "lodash";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalUserTransaction, setSelectedUserTransaction }) {
  // useEffect(() => {
  // if (!_.isEmpty(location.state) && _.isNumber(location.state?.id)) {
  // }
  // }, [location]);

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "basketId",
        Header: "شماره سفارش",
        minWidth: 50,
      },
      {
        accessor: "userFullName",
        Header: "نام",
        minWidth: "100px",
      },
      {
        Header: "مبلغ ریالی",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) =>
          row.original.balanceType === 1 ? (
            <div className="text-center" style={{ color: "#099145" }}>
              <ArrowUpwardIcon />
              <SplitNumber number={row.original.amount} />
            </div>
          ) : (
            <div className="text-center text-danger">
              <ArrowDownwardIcon />
              <SplitNumber number={row.original.amount} />
            </div>
          ),
      },
      {
        Header: "مبلغ اعتباری",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => <SplitNumber number={row.original.creditAmount} />,

        // row.original.balanceType === 1 ? (
        //   <div className="text-center" style={{ color: "#099145" }}>
        //     <ArrowUpwardIcon />
        //     <SplitNumber number={row.original.creditAmount} />
        //   </div>
        // ) : (
        //   <div className="text-center text-danger">
        //     <ArrowDownwardIcon />
        //     <SplitNumber number={row.original.creditAmount} />
        //   </div>
        // ),
      },
      {
        accessor: "strType",
        Header: "نوع تراکنش",
        minWidth: 100,
        align: "center",
      },
      {
        Header: "تاریخ انجام",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {_.toString(row.original.completionDate)} - {_.toString(row.original.completionTime)}
          </div>
        ),
      },
      {
        accessor: "description",
        Header: "توضیحات",
        minWidth: "100px",
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* مشاهده  */}
            <Button
              title="مشاهده اطلاعات"
              className="btn btn-light-info btn-sm mr-2 btn-icon"
              onClick={() => {
                setSelectedUserTransaction(row.original.id);
                setShowModalUserTransaction(true);
              }}
            >
              <i className="far fa-eye text-small"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
